<p i18n="@@cookieConsent.banner.body">
  We use necessary cookies to run the platform and optional analytics to improve it. You can change this anytime in
  Privacy settings.
</p>
<div class="actions">
  <button
    type="button"
    noxo-button="secondary"
    (click)="rejectAll.emit()"
    i18n="@@cookieConsent.action.rejectAll">
    Only necessary
  </button>
  <button
    type="button"
    noxo-button="primary"
    (click)="acceptAll.emit()"
    i18n="@@cookieConsent.action.acceptAll">
    Accept all
  </button>
</div>
